
import { BIO_CATEGORY_THRESHOLDS } from '@/core/BusinessRulesEngine';

export type BioCategoryLevel = 'péssimo' | 'muito ruim' | 'ruim' | 'razoável' | 'bom' | 'ótimo' | 'excelente';

export interface BioCategory {
  level: BioCategoryLevel;
  color: string;
  bgColor: string;
  progressValue: number;
  showFeedback: boolean;
  icon: string;
  motivationalMessage?: string;
}

export const getBioCategoryFromScore = (score: number): BioCategory => {
  if (score >= BIO_CATEGORY_THRESHOLDS.EXCELLENT) {
    return {
      level: 'excelente',
      color: 'text-emerald-400',
      bgColor: 'bg-emerald-500',
      progressValue: 100,
      showFeedback: false,
      icon: '🌟',
      motivationalMessage: 'Sua bio está perfeita!'
    };
  } else if (score >= 75 && score < BIO_CATEGORY_THRESHOLDS.EXCELLENT) {
    return {
      level: 'ótimo',
      color: 'text-green-400',
      bgColor: 'bg-green-500',
      progressValue: 85,
      showFeedback: true,
      icon: '✨',
      motivationalMessage: 'Sua bio está quase perfeita!'
    };
  } else if (score >= BIO_CATEGORY_THRESHOLDS.GOOD) {
    return {
      level: 'bom',
      color: 'text-blue-400',
      bgColor: 'bg-blue-500',
      progressValue: 70,
      showFeedback: true,
      icon: '👍',
      motivationalMessage: 'Sua bio está boa!'
    };
  } else if (score >= 50 && score < BIO_CATEGORY_THRESHOLDS.GOOD) {
    return {
      level: 'razoável',
      color: 'text-yellow-400',
      bgColor: 'bg-yellow-500',
      progressValue: 55,
      showFeedback: true,
      icon: '⚡',
      motivationalMessage: 'Sua bio está no caminho certo!'
    };
  } else if (score >= 35 && score < 50) {
    return {
      level: 'ruim',
      color: 'text-orange-400',
      bgColor: 'bg-orange-500',
      progressValue: 40,
      showFeedback: true,
      icon: '⚠️',
      motivationalMessage: 'Sua bio precisa de melhorias'
    };
  } else if (score >= 20) {
    return {
      level: 'muito ruim',
      color: 'text-red-400',
      bgColor: 'bg-red-600',
      progressValue: 25,
      showFeedback: true,
      icon: '🔴',
      motivationalMessage: 'Continue escrevendo para melhorar'
    };
  } else {
    return {
      level: 'péssimo',
      color: 'text-red-500',
      bgColor: 'bg-red-700',
      progressValue: 10,
      showFeedback: true,
      icon: '❌',
      motivationalMessage: 'Comece escrevendo sobre você'
    };
  }
};

